import React, { useEffect } from 'react'
import { getUrlParam } from '@/libs/functions/getValue'
import goTo from '@/libs/functions/goTo'

const index = () => {
  const redirectUrl = getUrlParam('redirectUrl')
  useEffect(() => {
    // 清除登录
    window.localStorage.removeItem('h5Token')
    window.sessionStorage.removeItem('h5Token')
    if (redirectUrl)
      goTo(decodeURIComponent(redirectUrl), {
        type: 'replace',
      })
  }, [redirectUrl])
  return <div></div>
}

export default index
